import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: false, text: "Box" },
  { value: true, text: "pcs" },
]);
